// extracted by mini-css-extract-plugin
export default {"title":"Partnership_title__xVh14","title_desktop":"Partnership_title_desktop__f+8y-","content":"Partnership_content__v-lHz","desktop":"Partnership_desktop__uRmsY"};